module.exports = "/_next/static/images/hero-desktop-bea70c86b6fbc56865b58b8fb8237640.svg";